module.exports = __webpack_public_path__ + "media/images/success_header_bg-700655a0b83922ba296e47eeb8d29109.gif";